import { createGlobalStyle, css } from 'styled-components';

// Util for creating an inner selector for all Combobox derivatives
const selector = (name: string) =>
  ['Combobox', 'Select', 'MultiSelect', 'Autocomplete', 'Menu'] // Names of components that derive from Combobox
    .map((component) => `.mantine-${component}-${name}`)
    .join(',');

// Global styles to be used by all Combobox derivatives
export const GlobalComboboxStyles = createGlobalStyle(
  ({ theme }) => css`
    ${selector('input')},
    .mantine-Input-input {
      ${theme.typography.bodyMd1};
      font-family: ${theme.fontFamily};
      min-height: ${theme.input.select.height};
      border-radius: ${theme.borderRadius.sm};
      background: ${theme.palette.neutral['00']};
      border: 1px solid ${theme.palette.neutral[70]};

      @media (min-resolution: 2x) {
        // Darker sub-pixel border for retina screens
        border: 0.5px solid ${theme.palette.neutral[90]};
      }

      &:focus,
      &:focus-visible,
      &[data-expanded] {
        box-sizing: border-box;
        outline: 2px solid ${theme.palette.neutral['100']};
      }
    }

    ${selector('dropdown')} {
      min-width: 200px;
      border-radius: ${theme.borderRadius.sm};
      background-color: ${theme.palette.neutral['00']};
      border: 0.5px solid ${theme.palette.neutral[70]};
      padding: 0;
      overflow: hidden;
    }

    ${selector('options')} {
      max-height: 320px;
      overflow-y: auto;
    }

    ${selector('label')} {
      ${theme.typography.bodySm2};
    }

    ${selector('option')} {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: ${theme.spacing(1.5, 2)};
      border-radius: 0;

      &:not(:last-child) {
        border-bottom: 1px solid ${theme.palette.neutral[60]};
      }

      &:where([data-combobox-selected]) {
        background-color: ${theme.palette.neutral[40]};
        color: inherit;
      }

      svg {
        color: ${theme.palette.primary.main};
        opacity: 1;
      }
    }

    ${selector('empty')} {
      ${theme.typography.bodyMd1};
      color: ${theme.palette.neutral[100]};
      padding: ${theme.spacing(1.5, 2)};
    }

    /* Rotate Select chevron when expanded */
    .mantine-Select-chevron,
    .mantine-MultiSelect-chevron {
      transition: transform 200ms;

      .mantine-Select-input[data-expanded] + div &,
      .mantine-MultiSelect-input[data-expanded] + div & {
        transform: rotate(180deg);
      }
    }
  `
);
